import {Grid, WithStyles, withStyles} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import cn from 'classnames'
import {Trans} from 'react-i18next'
import messages from '../../../../../../../../assets/messages'
import {styles} from '../styles'

type PendingApprovalBadgeProps = WithStyles<typeof styles> & {
  classNames?: {
    text: string,
    background: string,
  }
}

const _PendingApprovalBadge = ({classes, classNames}: PendingApprovalBadgeProps) => (
  <Grid item className={cn(classes.pending, classes.isDemoArchived, classNames?.background)}>
    <Typography variant='caption' className={cn(classes.pendingText, classNames?.text)}><Trans {...messages.pendingApproval} /></Typography>
  </Grid>

)

export const PendingApprovalBadge = withStyles(styles, {withTheme: true})(_PendingApprovalBadge)
